import { ComponentChild, h, JSX } from 'preact';

// Inspired by Stack component from MUI: https://mui.com/material-ui/react-stack/

interface StackProps {
    direction?: 'row' | 'column';
    justifyContent?: 'center' | 'space-between'; // TODO more values
    alignItems?: 'baseline' | 'center'; // TODO more values
    gap?: number;
    class?: string;
    children: ComponentChild;
}

const SCALING_FACTOR = 8;

const getStyle = (props: StackProps): JSX.CSSProperties => {
    const style: JSX.CSSProperties = {
        display: 'flex',
        flexDirection: props.direction,
        justifyContent: props.justifyContent,
        alignItems: props.alignItems,
    };

    if (props.gap) {
        style.gap = props.gap * SCALING_FACTOR;
    }

    return style;
};

export const Stack = (props: StackProps): JSX.Element => (
    <div style={getStyle(props)} class={props.class}>{props.children}</div>
);
